module.exports = __webpack_public_path__ + "static/entrepreneur-1-2024-12e84152c3adfff80295f13cbebb8840.webp";